import { render, staticRenderFns } from "./OrderRouteFormModal.vue?vue&type=template&id=2f2864ee&"
import script from "./OrderRouteFormModal.vue?vue&type=script&lang=js&"
export * from "./OrderRouteFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports